export default function PrintableStatus({ status = '' }) {
  if (status === 'draft') {
    return <span className="myShop-status status-gray">{status}</span>
  }
  if (status === 'rejected' || status === 'inactive') {
    return <span className="myShop-status status-orange">{status}</span>
  }
  if (status === 'active' || status === 'in review') {
    return <span className="myShop-status status-green">{status}</span>
  }
  return <span className="myShop-status status-gray">{status}</span>
}
